import React, { useEffect, useState, useRef } from 'react';

// This component expects 'mapGoogle' (the Google Map instance)
// and 'googleMapsApi' (the window.google.maps object) as props.
const CurrentLocationMapGoogle = ({ map, googleMapsApi }) => {
    const [currentLocationMarker, setCurrentLocationMarker] = useState(null);
    const [accuracyCircle, setAccuracyCircle] = useState(null);
    const [isLocationVisible, setIsLocationVisible] = useState(false);

    const watchIdRef = useRef(null); // To store the ID from watchPosition

    // Function to handle location updates
    const handleLocationUpdate = (position) => {
        if (!map || !googleMapsApi) return;
        const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
        };
        // Update or create the marker
        if (currentLocationMarker) {
            currentLocationMarker.setPosition(pos);
        } else {
            const marker = new googleMapsApi.Marker({
                position: pos,
                map: map,
                title: 'Your Location',
                // Optional: Use a custom icon for the current location
                icon: {
                    path: googleMapsApi.SymbolPath.CIRCLE,
                    scale: 7,
                    fillColor: '#4285F4', // Google Blue
                    fillOpacity: 1,
                    strokeWeight: 2,
                    strokeColor: 'white',
                }
            });
            setCurrentLocationMarker(marker);
        }

        // Update or create the accuracy circle
        if (position.coords.accuracy) {
            if (accuracyCircle) {
                accuracyCircle.setCenter(pos);
                accuracyCircle.setRadius(position.coords.accuracy);
            } else {
                const circle = new googleMapsApi.Circle({
                    strokeColor: '#4285F4',
                    strokeOpacity: 0.6,
                    strokeWeight: 1,
                    fillColor: '#4285F4',
                    fillOpacity: 0.2,
                    map: map,
                    center: pos,
                    radius: position.coords.accuracy, // Accuracy in meters
                });
                setAccuracyCircle(circle);
            }
        }
        setIsLocationVisible(true);
    };

    const handleLocationError = (error) => {
        let message = 'Error retrieving location: ';
        switch (error.code) {
            case error.PERMISSION_DENIED:
                // message += "User denied the request for Geolocation.";
                message += "قام المستخدم برفض طلب تحديد الموقع الجغرافي.";
                break;
            case error.POSITION_UNAVAILABLE:
                // message += "Location information is unavailable.";
                message += "معلومات الموقع غير متوفرة.";
                break;
            case error.TIMEOUT:
                // message += "The request to get user location timed out.";
                message += "انتهت مهلة طلب الحصول على موقع المستخدم";
                break;
            default:
                // message += "An unknown error occurred.";
                message += "حدث خطأ غير معروف.";
                break;
        }
        console.error(message, error);
        // Optionally, display this error to the user
    };

    // useEffect(() => {
    //     if (!map || !googleMapsApi || !navigator.geolocation) {
    //         return;
    //     }
    //     // Start watching the user's position
    //     watchIdRef.current = navigator.geolocation.watchPosition(
    //         handleLocationUpdate,
    //         handleLocationError,
    //         {
    //             enableHighAccuracy: true,
    //             timeout: 5000, // How long to wait for a response
    //             maximumAge: 0, // Don't use a cached position
    //         }
    //     );
    //
    //     // Cleanup function: stop watching when the component unmounts
    //     return () => {
    //         if (watchIdRef.current !== null) {
    //             navigator.geolocation.clearWatch(watchIdRef.current);
    //             watchIdRef.current = null;
    //         }
    //         // Remove marker and circle from map
    //         if (currentLocationMarker) {
    //             currentLocationMarker.setMap(null);
    //             setCurrentLocationMarker(null);
    //         }
    //         if (accuracyCircle) {
    //             accuracyCircle.setMap(null);
    //             setAccuracyCircle(null);
    //         }
    //     };
    // }, [map, googleMapsApi]); // Rerun if map or googleMapsApi instance changes


    // --- Optional: Add a custom "My Location" button ---
    useEffect(() => {
        if (!map || !googleMapsApi) return;

        const controlButton = document.createElement('button');
        // Style the button to look like other Google Maps controls
        controlButton.style.backgroundColor = '#fff';
        controlButton.style.border = '2px solid #fff';
        controlButton.style.borderRadius = '3px';
        controlButton.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
        controlButton.style.cursor = 'pointer';
        controlButton.style.margin = '10px'; // Margin for placement
        controlButton.style.padding = '8px';
        controlButton.title = 'Show my location';
        // You can use an SVG icon or text
        controlButton.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24"><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"></path></svg>`; // Material Design 'my_location' icon

        controlButton.addEventListener('click', () => {
            if (isLocationVisible) {
                // Hide marker and accuracy circle
                if (currentLocationMarker) {
                    currentLocationMarker.setMap(null);
                    setCurrentLocationMarker(null);
                }
                if (accuracyCircle) {
                    accuracyCircle.setMap(null);
                    setAccuracyCircle(null);
                }
                setIsLocationVisible(false);
            } else {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            const pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };
                            map.setCenter(pos);
                            map.setZoom(15); // Or your preferred zoom level
                            handleLocationUpdate(position); // Update marker/circle too
                        },
                        handleLocationError,
                        {enableHighAccuracy: false, timeout: 10000, maximumAge: 60000}
                    );
                }
            }
        });

        // Add the button to the map
        map.controls[googleMapsApi.ControlPosition.RIGHT_BOTTOM].push(controlButton);

        // Cleanup the button
        return () => {
            const controls = map.controls[googleMapsApi.ControlPosition.RIGHT_BOTTOM];
            for (let i = 0; i < controls.getLength(); i++) {
                if (controls.getAt(i) === controlButton) {
                    controls.removeAt(i);
                    break;
                }
            }
        };

    }, [map, googleMapsApi, handleLocationUpdate]); // Add handleLocationUpdate as it's used in click

    return null; // This component manipulates the map directly
};

export default CurrentLocationMapGoogle;